import Core from "Core";

export class UsersStore extends Core.Stores.ModelStore {
  constructor(modelType, store) {
    super(modelType, "/api/public/users.php", store);
  }

  beforeUpdateFromJson() {
    this.clear();
  }

  fetchByCustomerId(customerId) {
    this.fetch(`?customerId=${customerId}`);
  }
}



// WEBPACK FOOTER //
// ./src/Stores/DataStore/UsersStore.js